export const MobileLanguageController = () => {
  $('#mobile-language').on('change', (e) => {
    const url = $(e.currentTarget).find(':selected').attr('data-url');
    window.location = url;
  })
}



// WEBPACK FOOTER //
// ./src/js/controllers/MobileLanguageController.js